export const REACT_SNAP_ACTIVE = navigator.userAgent === 'ReactSnap';
